<template>
  <div class="navbar-fixed-content" style="padding-top:70px;">
    <div class="about-contrainer">
        <div class="cnt">
        
            <div class="about-con" style="width: 100%;">
                <h2>关于我们</h2>
                <p>
                    师培在线是景格科技公司为老师们倾力打造的线上及线下实用技能学习平台，该平台于6月30日正式上线，目前拥有Web端、移动端(Android、iOS)，为学习者提供海量优质的课程，课程结构严谨，设计合理，我们将根据用户自身的学习程度为其安排合理的学习课程。
                    师培在线的宗旨是：为每一个想提升自我的老师提供真正学习到实用知识、技能的平台。
                </p>
                <p>
                    立足于实用性与先进性的要求，师培在线精选出各类课程，导师从学科骨干新教师覆盖到校长科长班主任，我们十年磨一剑，力争从职业成长等方面为用户打造一个实用学习的多维度平台。
                </p>
                <p>
                    三大优势<br>
                    课程专注师资能力、聚焦职教培训<br>
                    这里有精心制作的视频课程<br>
                    ——导师来源于国内顶尖高校，课程内容接地气，致力于师资能力的提升<br>
                    这里有循序渐进的学习计划<br>
                    ——专治学习迷茫症，有导师有目标有路径，一切尽在掌握中<br>
                    这里有实时交互的线上线下培训<br>
                    ——从线上到线下，导师零距离指点，全方位培训学习技能，<br>
                    这里有互帮互助的学习班级<br>
                    ——有问有答有分享，良师益友共交流<br>

                </p>
              
                
            </div>
        </div>
    </div>
</div>
</template>

<script>


export default {
  name: "about",

};
</script>

